import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const FilterIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path d="M5 3H18" stroke={props.color} strokeWidth="1.5"/>
      <path d="M0 15H2M18 15H10" stroke={props.color} strokeWidth="1.5"/>
      <path d="M0 9H12" stroke={props.color} strokeWidth="1.5"/>
      <circle cx="3" cy="3" r="2" stroke={props.color} strokeWidth="1.5"/>
      <circle cx="14" cy="9" r="2" stroke={props.color} strokeWidth="1.5"/>
      <circle cx="6" cy="15" r="2" stroke={props.color} strokeWidth="1.5"/>
    </SvgCommon>
  );
};